<template>
  <div class="withdraw" v-loading="loading">
    <div class="withdraw-first">
      <div class="withdraw-first-top">
        <div
          class="top-list"
          v-for="(item, index) in withdrawTitleList"
          :key="index"
          :class="{ active: withdrawTitleIndex == index }"
          @click="titleBtn(index, item)"
        >
          <div class="top-list-title">{{ item.title }}</div>
          <div class="top-list-lint" v-if="withdrawTitleIndex == index"></div>
        </div>
      </div>

      <div class="withdraw-first-center">
        <div class="first-center-list" v-for="(item, index) in 5" :key="index">
          <div class="first-center-list-title">
            {{
              index == 0
                ? '用户id'
                : index == 1
                ? '用户手机号'
                : index == 2
                ? '提现方式'
                : index == 3
                ? '审核状态'
                : index == 4
                ? '开始时间'
                : ''
            }}
          </div>

          <div class="first-center-list-input">
            <el-input
              v-if="index == 0"
              v-model="withdrawUserid"
              clearable
              placeholder="请输入用户id"
            ></el-input>
            <el-input
              v-if="index == 1"
              v-model="withdrawPhone"
              clearable
              placeholder="请输入用户电话"
            ></el-input>
            <el-select
              v-if="index == 2"
              v-model="incomeStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in incomeOptions"
                :key="item.label"
                :label="item.title"
                :value="item.label"
              >
              </el-option>
            </el-select>

            <el-select
              v-if="index == 3"
              v-model="withdrawStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in withdrawOptions"
                :key="item.label"
                :label="item.title"
                :value="item.label"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-if="index == 4"
              value-format="yyyy-MM-dd"
              v-model="withdrawPaymentTime"
              type="daterange"
              range-separator=""
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </div>
      </div>

      <div class="withdraw-first-bottom">
        <div class="first-bottom-inquire" @click="withdrawInquire">查询</div>
        <div class="first-bottom-reset" @click="withdrawReset">重置</div>
      </div>
    </div>

    <div class="withdraw-second">
      <div class="withdraw-second-div">
        <div class="withdraw-second-div-left">查询结果</div>
        <div class="withdraw-second-div-right">
          <div class="withdraw-second-div-right-refresh" @click="refreshClick">
            刷新
          </div>
        </div>
      </div>

      <div class="withdraw-second-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border=""
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <!-- <el-table-column prop="userTeamEarnestPriceLogId" label="收益记录id" width="120"></el-table-column> -->
          <el-table-column
            prop="nickname"
            label="用户名称"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="userId"
            label="用户id"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="用户手机号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="提现金额"
            width="200"
          ></el-table-column>
          <el-table-column prop="" label="提现方式" width="200">
            <template slot-scope="scope">
              {{
                scope.row.payType == 0
                  ? '银行卡提现'
                  : scope.row.payType == 2
                  ? '微信提现'
                  : scope.row.payType == 3
                  ? '支付宝提现'
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="bank_account"
            label="提现账号"
            width="200"
          ></el-table-column>

          <el-table-column
            prop="orderNum"
            label="订单号"
            width="200"
          ></el-table-column>

          <el-table-column
            prop="payCode"
            label="流水号"
            width="250"
          ></el-table-column>

          <el-table-column
            prop="createTime"
            label="申请时间"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="处理时间"
            width="200"
          ></el-table-column>
          <el-table-column label="审核状态" width="150">
            <template slot-scope="scope">
              <div
                :style="{
                  color:
                    scope.row.withdrawStatus == 'PASS'
                      ? '#36C100'
                      : scope.row.withdrawStatus == 'REFUSE'
                      ? '#FF3333'
                      : '#F9B63C',
                }"
              >
                {{
                  scope.row.withdrawStatus == 'PASS'
                    ? '同意'
                    : scope.row.withdrawStatus == 'REFUSE'
                    ? '拒绝'
                    : scope.row.withdrawStatus == 'UNDEFINED'
                    ? '未处理'
                    : ''
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" label="操作" width="106" fixed="right">
            <template slot-scope="scope">
              <div
                class="table-operation"
                v-if="scope.row.withdrawStatus == 'UNDEFINED'"
              >
                <div
                  class="table-operation-title"
                  @click="auditClick(scope.row)"
                >
                  审核
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="integral-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <div class="information">
      <el-dialog
        :visible.sync="informationDialogVisible"
        @close="informationCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="information-title">
            <div class="title">提现信息详情</div>
            <img
              @click="informationCancel"
              class="img"
              src="../../assets/common/close.png"
              alt=""
            />
          </div>

          <div class="information-div">
            <div class="div">
              <div class="div-list" v-for="(item, index) in 5" :key="index">
                <div class="list-title">
                  {{
                    index == 0
                      ? '申请用户'
                      : index == 1
                      ? '用户id'
                      : index == 2
                      ? '申请时间'
                      : index == 3
                      ? '收益记录id'
                      : index == 4
                      ? '用户手机号'
                      : ''
                  }}
                </div>

                <div class="list-value">
                  {{
                    index == 0
                      ? informationObj.nickname
                      : index == 1
                      ? informationObj.userId
                      : index == 2
                      ? informationObj.createTime
                      : index == 3
                      ? informationObj.userTeamEarnestPriceLogId
                      : index == 4
                      ? informationObj.phone
                      : ''
                  }}
                </div>
              </div>
            </div>

            <div class="div" style="border-bottom: 0">
              <div class="div-list" v-for="(item, index) in 6" :key="index">
                <div class="list-title">
                  {{
                    index == 0
                      ? '提现方式'
                      : index == 1
                      ? informationObj.bank_name + '姓名'
                      : index == 2
                      ? informationObj.bank_name + '账号'
                      : index == 3
                      ? informationObj.bank_name + '卡绑定手机号'
                      : index == 4
                      ? '提现金额'
                      : index == 5
                      ? '审核状态'
                      : ''
                  }}
                </div>

                <div class="list-value">
                  {{
                    index == 0
                      ? informationObj.bank_name + '提现'
                      : index == 1
                      ? informationObj.realname
                      : index == 2
                      ? informationObj.bank_account
                      : index == 3
                      ? informationObj.phone
                      : index == 4
                      ? informationObj.price
                      : index == 5
                      ? informationObj.withdrawStatus == 'PASS'
                        ? '同意'
                        : informationObj.withdrawStatus == 'REFUSE'
                        ? '拒绝'
                        : informationObj.withdrawStatus == 'UNDEFINED'
                        ? '未处理'
                        : ''
                      : ''
                  }}
                </div>
              </div>
            </div>

            <div
              class="div"
              v-if="informationObj.payType == 2"
              style="padding-top: 0"
            >
              <div class="div-list">
                <div class="list-title">银行类型</div>

                <div class="list-value">浦发银行</div>
              </div>
            </div>
          </div>

          <div class="information-block">
            <div class="block-title">审核消息发送</div>
            <div class="block-select">
              <div class="select-title">修改审核状态</div>
              <div class="select">
                <el-select
                  v-model="withdrawValue"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in withdrawOptions"
                    :key="item.label"
                    :label="item.title"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="block-text">审核理由</div>
            <div class="block-textarea">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="informationTextarea"
                maxlength="200"
                show-word-limit
              >
              </el-input>

              <div class="textarea-display">
                <el-upload
                  class="display-upload"
                  action="https://laravel-api-manager.xmw1688.com/common/upload"
                  list-type="picture-card"
                  :on-success="handleSuccessList"
                  :limit="3"
                  :show-file-list="false"
                  ref="upload"
                >
                  <div
                    class="display-upload-list"
                    v-for="(item, index) in withdrawList"
                    :key="index"
                  >
                    <img class="display-upload-list-img" :src="item" alt="" />
                    <img
                      class="display-upload-detele"
                      src="../../assets/common/common-detele.png"
                      alt=""
                      @click.stop="informationList(index)"
                    />
                  </div>
                  <img
                    class="display-upload-list"
                    style="cursor: pointer"
                    src="../../assets/common/common-uploadings.png"
                    v-if="withdrawList.length < 3"
                  />
                </el-upload>
              </div>
            </div>
          </div>
          <div class="information-button">
            <!-- <div class="button-reset" @click="abilityReset">重 置</div> -->
            <div class="button-confirm" @click="informationConfirm">确 定</div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--第二区域  进行禁用-->
    <div class="audit">
      <el-dialog
        :visible.sync="auditDialogVisible"
        style="margin-top: 10vh"
        @close="auditCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="audit-password">
            <div class="password">
              <img
                class="password-img"
                src="../../assets/common/common-warning.png"
              />
            </div>

            <div class="title">是否确定修改审核状态？</div>
            <div class="text">一旦确定后则不能更改，并且用户会收到审核信息</div>
          </div>

          <div class="audit-button">
            <div class="button-left" @click="auditConfirm">确定</div>
            <div class="button-right" @click="auditCancel">取消</div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getEarnest, postEarnest } from '../../api/partenr'

export default {
  data() {
    return {
      // 第一区域 表头数组
      withdrawTitleList: [
        {
          label: '',
          title: '全部',
        },
        {
          label: 'UNDEFINED',
          title: '未处理',
        },
        {
          label: 'PASS',
          title: '同意',
        },
        {
          label: 'REFUSE',
          title: '申请驳回',
        },
      ],
      // 第一区域 表头数组下标选中
      withdrawTitleIndex: 0,
      // 第一区域 用户id
      withdrawUserid: '',
      withdrawName: '',
      withdrawPhone: '',
      incomeStatus: '', // 收益状态
      incomeOptions: [
        {
          label: '0',
          title: '银行卡',
        },
        {
          label: '1',
          title: '微信',
        },
        {
          label: '2',
          title: '支付宝',
        },
      ],
      withdeawType: '',
      typeOptions: [
        {
          label: '0',
          title: '返利链产升',
        },
        {
          label: '1',
          title: '自己返利',
        },
        {
          label: '-1',
          title: '取钱',
        },
      ],
      withdrawStatus: '',
      withdrawValue: '',
      withdrawOptions: [
        {
          label: 'PASS',
          title: '同意',
        },
        {
          label: 'REFUSE',
          title: '拒绝',
        },
        {
          label: 'UNDEFINED',
          title: '未处理',
        },
      ],
      withdrawPaymentTime: [],
      withdrawPaymentTimeA: '',
      withdrawPaymentTimeB: '',
      // 页码
      page: 1,
      // 页数
      limit: 10,

      // 第二区域 表格数组
      tableData: [],
      // 第二区域 表格总条数
      totalNum: 0,
      // 存储表格选中的值
      multipleSelection: [],

      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      withdrawFunShow: false,

      // 弹出框
      informationDialogVisible: false,
      informationObj: {},
      informationOption: [
        {
          index: 0,
          title: '待审核',
        },
        {
          index: 1,
          title: '已通过',
        },
        {
          index: 2,
          title: '已驳回',
        },
      ],
      informationTextarea: '',
      //----------上传
      withdrawList: [],
      //-----------弹出框
      auditDialogVisible: false,
      ceshi0: 0,
    }
  },
  created() {
    this.loading = false
    // 获取销售订单基本数据
    this.getEarnestClick()

    setTimeout(() => {
      this.withdrawFunShow = this.$store.state.pageFunctionShow
    }, 1000)
  },
  methods: {
    getEarnestClick() {
      let params = {
        userId: this.withdrawUserid,
        userName: this.withdrawName,
        userPhone: this.withdrawPhone,
        status: '',
        createStartTime: this.withdrawPaymentTimeA,
        createEndTime: this.withdrawPaymentTimeB,
        type: -1,
        withdrawStatus: this.withdrawStatus,
        payType: this.incomeStatus,
        pageNo: this.page,
        pageSize: this.limit,
      }

      getEarnest(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.earnestList
          // 获取总数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 点击对应分类进行切换
    titleBtn(index, item) {
      this.withdrawTitleIndex = index
      this.withdrawStatus = item.label
      this.loading = true
      this.getEarnestClick()
    },
    withdrawInquire() {
      // 订单支付时间
      if (
        this.withdrawPaymentTime != null &&
        this.withdrawPaymentTime.length != 0
      ) {
        this.withdrawPaymentTimeA = this.withdrawPaymentTime[0]
        this.withdrawPaymentTimeB = this.withdrawPaymentTime[1]
      } else {
        this.withdrawPaymentTimeA = ''
        this.withdrawPaymentTimeB = ''
      }

      this.$nextTick(() => {
        this.getEarnestClick()
      })
    },
    withdrawReset() {
      this.withdrawUserid = ''
      this.withdrawName = ''
      this.withdrawPhone = ''
      this.incomeStatus = ''
      this.withdeawType = ''
      this.withdrawStatus = ''
      this.withdrawPaymentTime = []
      this.withdrawPaymentTimeA = ''
      this.withdrawPaymentTimeB = ''
      this.withdrawTitleIndex = 0

      this.loading = true
      this.getEarnestClick()
    },
    // 刷新
    refreshClick() {
      this.loading = true
      this.getEarnestClick()
    },
    // 表格区域点击选中 勾选对应的
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 审核  弹出框
    auditClick(item) {
      if (this.withdrawFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }

      this.informationObj = item
      this.withdrawValue = item.withdrawStatus

      //-------------

      if (item.reason != null) {
        let text = item.reason.split(';')
        let array = []
        let title = ''

        text.forEach((item, index) => {
          if (item.substring(0, 23) == 'https://oss.xmw1688.cn') {
            array.push(item)
          } else {
            title = item
          }
        })

        this.informationTextarea = title
        this.withdrawList = array
      }

      this.informationDialogVisible = true
    },
    informationCancel() {
      this.informationDialogVisible = false
    },

    // 上传
    handleSuccessList(file, fileList) {
      this.$refs.upload.clearFiles()
      this.withdrawList.push(file.resultData)
    },
    informationList(index) {
      this.withdrawList.splice(index, 1)
    },

    // 二次取消  确定
    auditCancel() {
      this.auditDialogVisible = false
    },
    auditConfirm() {
      if (this.withdrawList.length > 0) {
        var img = this.withdrawList.join(';')
        var str = this.informationTextarea + ';' + img
      } else {
        var str = this.informationTextarea
      }

      if (str == ';') {
        str = ''
      }
      let params = {
        userTeamEarnestPriceLogId:
          this.informationObj.userTeamEarnestPriceLogId,
        withdrawStatus: this.withdrawValue,
        reason: str,
      }

      postEarnest(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '审核成功!',
            type: 'success',
          })

          this.informationDialogVisible = false
          this.auditDialogVisible = false
          this.informationTextarea = ''
          this.getEarnestClick()
        }
      })
    },

    informationConfirm() {
      if (this.withdrawValue == 'UNDEFINED') {
        this.$message.error('请先修改审核状态！')

        return
      }

      this.auditDialogVisible = true
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getEarnestClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getEarnestClick()
    },
  },
}
</script>

<style lang="less" scoped>
.withdraw {
  .withdraw-first {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px 24px;
    box-sizing: border-box;

    .withdraw-first-top {
      display: flex;
      height: 55px;
      border-bottom: 1px solid #f4f5f9;

      .top-list {
        width: 66px;
        height: 55px;
        position: relative;
        margin-right: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .top-list-lint {
          position: absolute;
          bottom: 0;
          width: 56px;
          height: 4px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 15px 15px 0px 0px;
        }
      }

      .active {
        .top-list-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }
      }
    }

    .withdraw-first-center {
      display: flex;
      margin-top: 20px;

      .first-center-list {
        margin-right: 22px;

        .first-center-list-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .first-center-list-input {
          width: 100%;
          margin-top: 4px;

          /deep/ .el-input {
            height: 32px;
            width: 186px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }

          /deep/ .el-range-editor.el-input__inner {
            padding: 0;
            padding: 0 12px;
            box-sizing: border-box;
          }

          /deep/ .el-date-editor--daterange.el-input__inner {
            width: 382px;
          }

          /deep/ .el-date-editor .el-range-separator {
            width: 26px;
            padding: 0;
            height: 32px;
            line-height: 32px;
            background-image: url('../../assets/activities/activities-right.png');
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .first-center-list:last-child {
        margin-right: 0;
      }
    }

    .withdraw-first-bottom {
      display: flex;
      margin-top: 27px;

      .first-bottom-inquire,
      .first-bottom-reset {
        width: 110px;
        height: 36px;
        background: #222222;
        border-radius: 10px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .first-bottom-reset {
        background: #f4f5f9;
        margin-left: 10px;
        color: #999999;
      }
    }
  }

  .withdraw-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;

    .withdraw-second-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .withdraw-second-div-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .withdraw-second-div-right {
        display: flex;
        align-items: center;
        justify-content: center;

        .withdraw-second-div-right-refresh {
          width: 70px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(34, 34, 34, 0.4);
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .withdraw-second-div-right-derive {
          width: 110px;
          height: 36px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .withdraw-second-div-right-derive-img {
            width: 12px;
            height: 12px;
          }

          .withdraw-second-div-right-derive-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    .withdraw-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table td.el-table__cell div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      /deep/ .el-table__cell {
        // vertical-align: top;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-img {
        height: 70px;
        background: #f0f0f0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 70px;
          height: 53px;
        }
      }

      .table-ordernum {
        .table-ordernum-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-ordernum-img {
          margin-top: 9px;
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }

      .table-recipients {
        .table-recipients-phone {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-recipients-address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          line-height: 22px;
          margin-top: 5px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .table-user {
        .table-user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-user-relation {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .table-commodity {
        display: flex;
        align-content: center;
        margin-bottom: 10px;

        .table-commodity-left {
          width: 70px;
          height: 70px;
          border: 1px solid #ccc;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .table-commodity-right {
          width: 196px;
          margin-left: 12px;

          .table-commodity-right-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 22px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .table-commodity-right-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            margin-top: 4px;
          }
        }
      }

      .table-commodity:last-child {
        margin-bottom: 0;
      }

      .table-commodityPrice {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        margin-bottom: 4px;
      }

      .table-commodityPrice:last-child {
        margin-bottom: 0;
      }

      .table-paytype {
        .table-paytype-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }

        .table-paytype-img {
          width: 34px;
          height: 34px;
          margin-top: 7px;
        }
      }

      .table-operation {
        display: flex;
        align-items: center;

        .table-operation-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .table-logistics {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .integral-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .information {
    /deep/ .el-dialog {
      width: 845px;
      height: 600px;
      overflow: auto;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .information-title {
      height: 56px;
      width: 100%;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .img {
        width: 11px;
        height: 10px;
        cursor: pointer;
      }
    }

    .information-div {
      .div {
        padding: 20px 24px 6px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;

        border-bottom: 1px solid #e8e8e8;

        .div-list,
        .div-list1 {
          width: calc(100% / 3 - 50px);
          text-align: left;
          margin-bottom: 14px;
          margin-right: 75px;

          .list-title {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }

          .list-value {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 20px;
            margin-top: 4px;
          }

          .list-img {
            display: flex;
            margin-top: 4px;

            .img1 {
              width: 150px;
              height: 149px;
              background: #f0f0f0;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 150px;
                height: 115px;
                object-fit: cover;
              }
            }
          }
        }

        .div-list:nth-child(3n + 3) {
          margin-right: 0;
        }

        .div-list1 {
          width: 100%;
        }
      }
    }

    .information-block {
      padding: 21px 23px;
      box-sizing: border-box;
      text-align: left;

      .block-title {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .block-select {
        margin-top: 12px;

        .select-title {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .select {
          margin-top: 5px;
        }
      }

      .block-text {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 14px;
      }

      .block-textarea {
        height: 206px;
        background: #ffffff;
        border-radius: 5px;
        border: 1px solid #d9d9d9;
        margin-top: 5px;
        padding: 0 12px;
        box-sizing: border-box;

        /deep/ .el-textarea__inner:hover {
          border: 0;
        }

        /deep/ .el-textarea__inner {
          border: 0;
          resize: none;
          height: 100px;
        }

        .textarea-display {
          .display-upload {
            display: flex;

            /deep/ .el-upload--picture-card {
              width: 100%;
              height: 100px;
              display: flex;
              align-items: center;
              border: 1px solid rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload--picture-card:hover {
              border-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 84px;
              height: 84px;
              margin: 0;
            }

            .display-upload-list {
              width: 84px;
              height: 84px;
              margin-right: 24px;
              position: relative;
              border: 1px solid rgba(255, 255, 255, 0);

              .display-upload-list-img {
                width: 84px;
                height: 84px;
              }
            }

            .display-upload-list:last-child {
              margin-right: 0;
            }

            .display-upload-detele {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .information-button {
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 16px;
      box-sizing: border-box;
      border-top: 1px solid #d9d9d9;
      margin-top: 25px;

      .button-reset,
      .button-confirm {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .button-confirm {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        color: #ffffff;
        margin-left: 8px;
      }
    }
  }

  .audit {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .audit-password {
      width: 100%;

      .password {
        display: flex;

        .password-img {
          width: 56px;
          height: 56px;
          margin: 0 auto;
        }
      }

      .title {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin: 15px 0 5px;
        text-align: center;
      }

      .text {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        text-align: center;
      }
    }

    .audit-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 30px;

      .button-left,
      .button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }
}
</style>
